import { Link } from "react-router-dom";
import { Gauge, Calendar, Fuel, Cog, ArrowUpRight } from "lucide-react";
import { formatPrice, formatKm } from "@/lib/api";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const FALLBACK_IMG = "https://images.unsplash.com/photo-1503376780353-7e6692767b70?crop=entropy&cs=srgb&fm=jpg&q=85";
const resolveImg = (u) => (u?.startsWith("/api/") ? `${BACKEND}${u}` : u);

export default function VehicleCard({ vehicle }) {
  const img = resolveImg(vehicle.images?.[0]) || FALLBACK_IMG;
  return (
    <Link
      to={`/fahrzeuge/${vehicle.id}`}
      data-testid={`vehicle-card-${vehicle.id}`}
      className="group flex flex-col bg-white border border-slate-200 hover:border-slate-900 hover:shadow-[0_20px_60px_-30px_rgba(15,23,42,0.35)] hover:-translate-y-1 transition-crisp"
    >
      <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
        <img
          src={img}
          alt={`${vehicle.make} ${vehicle.model}`}
          className="w-full h-full object-cover group-hover:scale-[1.04] transition-transform duration-700 ease-out"
          loading="lazy"
          onError={(e) => { e.target.src = FALLBACK_IMG; }}
        />
        <div className="absolute inset-0 bg-gradient-to-t from-slate-900/30 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity" />
        {vehicle.featured && !vehicle.sold && (
          <span className="absolute top-3 left-3 bg-white text-slate-900 text-[10px] uppercase tracking-[0.2em] px-2.5 py-1.5 font-medium">
            Empfohlen
          </span>
        )}
        {vehicle.sold && (
          <span className="absolute top-3 left-3 bg-red-600 text-white text-[10px] uppercase tracking-[0.2em] px-2.5 py-1.5 font-medium">
            Verkauft
          </span>
        )}
        <span className="absolute bottom-3 right-3 w-9 h-9 bg-white text-slate-900 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-crisp translate-y-2 group-hover:translate-y-0">
          <ArrowUpRight size={16} />
        </span>
      </div>

      <div className="p-5 flex flex-col gap-4 flex-1">
        <div>
          <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-1.5">{vehicle.make}</div>
          <h3 className="font-heading font-semibold text-lg text-slate-900 leading-tight group-hover:text-red-600 transition-crisp">{vehicle.model}</h3>
        </div>

        <div className="grid grid-cols-2 gap-y-2 gap-x-3 text-xs text-slate-600">
          <div className="flex items-center gap-1.5"><Calendar size={13} className="text-slate-400" /> {vehicle.first_registration}</div>
          <div className="flex items-center gap-1.5"><Gauge size={13} className="text-slate-400" /> {formatKm(vehicle.mileage)}</div>
          <div className="flex items-center gap-1.5"><Fuel size={13} className="text-slate-400" /> {vehicle.fuel_type}</div>
          <div className="flex items-center gap-1.5"><Cog size={13} className="text-slate-400" /> {vehicle.transmission}</div>
        </div>

        <div className="flex items-end justify-between pt-4 border-t border-slate-100 mt-auto">
          <div>
            <div className="text-[10px] uppercase tracking-[0.25em] text-slate-500">Preis</div>
            <div className="font-heading font-bold text-2xl text-slate-900">{formatPrice(vehicle.price)}</div>
          </div>
          <span className="text-xs text-slate-900 group-hover:text-red-600 transition-crisp font-medium link-underline">
            Details →
          </span>
        </div>
      </div>
    </Link>
  );
}
